import { ApolloLink } from 'apollo-link'
import { cleanGqlMeta } from '../utils'

/**
 * Custom link cleaning graphql metadata in variables
 */
export default new ApolloLink((operation, forward) => {
  operation.variables = cleanGqlMeta(operation.variables)
  return forward(operation)
})
